import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import KinosLeadModal from './components/KinosLeadModal';

import HeroSection from './components/HeroSection';
import TabbedFeaturesSection from './components/TabbedFeaturesSection';
import OurClients from './components/OurClients';
import Integrations from './components/Integrations';
import GuaranteeSection from './components/GuaranteeSection';
import FAQSection from './components/FAQSection';
import GotQuestionsSection from './components/GotQuestionsSection';

const Home = () => {
  const [demoModalOpen, setDemoModalOpen] = useState(false);

  // Force a consistent top-of-page start on load in hosted environments.
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    if (window.location.hash) {
      const cleanUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, '', cleanUrl);
    }
  }, []);

  // Smooth scroll for anchor links
  useEffect(() => {
    const anchors = Array.from(document.querySelectorAll('a[href^="#"]'));
    const handlers = anchors.map((anchor) => {
      const handleClick = (e) => {
        e.preventDefault();

        const targetId = anchor.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 100, // Offset for fixed header
            behavior: 'smooth',
          });
        }
      };

      anchor.addEventListener('click', handleClick);
      return { anchor, handleClick };
    });

    return () => {
      handlers.forEach(({ anchor, handleClick }) => {
        anchor.removeEventListener('click', handleClick);
      });
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow pb-20 sm:pb-0">
        <HeroSection onOpenDemo={() => setDemoModalOpen(true)} />
        <TabbedFeaturesSection />
        <OurClients />
        <GuaranteeSection />

        <Integrations />
        <FAQSection />
        <GotQuestionsSection onBookDemo={() => setDemoModalOpen(true)} />
      </main>

      <KinosLeadModal open={demoModalOpen} onClose={() => setDemoModalOpen(false)} email="" />

      <Footer />

      <div className="fixed bottom-0 left-0 right-0 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-white/40 backdrop-blur-md border-t border-gray-200/40 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] sm:hidden z-40">
        <a
          href="https://engagement.kolanut.ai/signup"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full py-3.5 rounded-full bg-green-600 text-white font-bold text-base shadow-lg hover:bg-green-700 active:scale-[0.98] transition-all duration-200"
        >
          Start Free Trial
        </a>
      </div>

      <style jsx global>{`
        html {
          scroll-behavior: smooth;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        section {
          animation: fadeIn 0.6s ease-out;
        }

        body {
          overflow-x: hidden;
        }
      `}</style>
    </div>
  );
};

export default Home;
